<template>
	<ZyroTooltip
		position="right"
		class="info"
		content-position="absolute"
		toggle-event="hover"
		:mode="mode"
	>
		<template #trigger>
			<button
				class="info__button"
			>
				<ZyroSvg
					name="help"
				/>
			</button>
		</template>
		<div class="info__content">
			<p class="z-body-small">
				{{ infoText }}
			</p>
		</div>
	</ZyroTooltip>
</template>

<script>
export default {
	props: {
		infoText: {
			type: String,
			default: '',
		},
		mode: {
			type: String,
			default: 'dark',
		},
	},
};

</script>

<style lang="scss" scoped>
.info {
	&__content {
		max-width: 200px;
	}

	&__button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		color: $grey-600;
	}
}
</style>
